var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.isMini
      ? _c(
          "div",
          { staticClass: "ob1-color-chips ob1-color-chips-mini" },
          [
            _c("span", { staticClass: "visually-hidden" }, [
              _vm._v("Groupe de couleurs disponibles non sélectionnables"),
            ]),
            _vm._v(" "),
            _vm._l(_vm.colors, function (color) {
              return _c(
                "span",
                {
                  key: "color-chips-mini-" + color.code,
                  staticClass: "ob1-color-chip",
                  style: "background-color: " + color.code + ";",
                },
                [
                  _c("span", {
                    directives: [
                      {
                        name: "safe-html",
                        rawName: "v-safe-html",
                        value: color.colorName,
                        expression: "color.colorName",
                      },
                    ],
                    staticClass: "ob1-color-chips-mini-tooltip",
                  }),
                ]
              )
            }),
          ],
          2
        )
      : _c(
          "fieldset",
          { staticClass: "ob1-color-chips" },
          [
            _c("legend", { staticClass: "visually-hidden" }, [
              _vm._v("\n            Coloris disponibles\n        "),
            ]),
            _vm._v(" "),
            _vm._l(_vm.colors, function (color, index) {
              return [
                _c("input", {
                  key: "color-chips-input-" + color.code,
                  staticClass: "ob1-color-chip-input",
                  attrs: {
                    id: _vm.id + "_" + color.inputName + "-" + index,
                    autocomplete: "off",
                    type: "radio",
                    name: color.inputName,
                  },
                  domProps: { checked: _vm.isChecked(color) ? "true" : null },
                  on: {
                    click: function ($event) {
                      return _vm.onColorChipsChange(color)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    key: "color-chips-label-" + color.code,
                    staticClass: "ob1-color-chip-label",
                    attrs: {
                      for: _vm.id + "_" + color.inputName + "-" + index,
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "ob1-color-chip",
                      style: "background-color: " + color.code + ";",
                    }),
                    _vm._v(" "),
                    _c("span", {
                      directives: [
                        {
                          name: "safe-html",
                          rawName: "v-safe-html",
                          value: color.colorName,
                          expression: "color.colorName",
                        },
                      ],
                      staticClass: "visually-hidden",
                    }),
                  ]
                ),
              ]
            }),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }